import React from "react";
import { Container, Content, Main } from "./Index.styled";
import Header from "../Header";
import Footer from "../Footer";
const Index = ({ children, productCode, productName }) => {
  return (
    <Container container column maxWidth="none">
      <Header productCode={productCode} productName={productName} />
      <Main>
        <Content>{children}</Content>
      </Main>
      <Footer />
    </Container>
  );
};

export default Index;
